import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonContent, IonHeader, IonFooter, useIonRouter } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../css/layout.css';

import { Preferences } from '@capacitor/preferences'

import { useHistory} from "react-router-dom";


export function CreateDeliveryFeeModal (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let deliveryAmountRef = useRef('');
    let deliveryCityRef = useRef('');
    let deliveryCityDistrictRef = useRef('');
    let deliveryRegionRef = useRef('');
    let deliveryCountryRef = useRef('');


    let history = useHistory();
    let router = useIonRouter();

    function handleRoute(event)
    {
        //alert(authenticatedMerchent_context.authenticated);

        //history.push(event);
        window.location.pathname = event;

    }


    function createDeliveryFee(e)
    {

        e.preventDefault();

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '33_delivery_fee_create',
                user: acctID,
                xDeliveryFeeAmount: deliveryAmountRef.current.value,
                xDeliveryFeeCity: deliveryCityRef.current.value,
                xDeliveryFeeCityDistrict: deliveryCityDistrictRef.current.value,
                xDeliveryFeeRegion: deliveryRegionRef.current.value,
                xDeliveryFeeCountry: deliveryCountryRef.current.value,
                //xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            let rows = data.toString().split('~~~');
            let cols = rows[0].split('|');

            //alert(authenticatedMerchent_context.initialSetup?.details?.step_2);
            alert(data);
    
        })
        .catch(error => {
            console.error(error);
        })
        //setAdminPasswordCreateInventoryItemModal(false);
    }


    function closeModalHandler() {

        props.closeModal(false);
    }

    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal}>
                    <form onSubmit={createDeliveryFee}>

                        <IonHeader style={{color: 'black'}}>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='12'>
                                        <h2>CREATE DELIVERY FEE </h2>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonHeader>
                        <IonContent className='grid_content'>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel className="form-label" position="stacked">Delivery Amount: </IonLabel>
                                                <IonInput className='professional-input' placeholder='Enter Delivery Amount' ref={deliveryAmountRef} required></IonInput>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel className="form-label" position="stacked">City: </IonLabel>
                                                <IonInput className='professional-input' placeholder='Enter Delivery City' ref={deliveryCityRef} required></IonInput>
                                            </IonCol>
                                        </IonRow>

                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel className="form-label" position="stacked">City District:  </IonLabel>
                                                 <IonInput className='professional-input' step='any' placeholder='Enter City District' ref={deliveryCityDistrictRef} required></IonInput>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonLabel className="form-label" position="stacked">Region:  </IonLabel>
                                                <IonInput className='professional-input' placeholder='Enter Region' ref={deliveryRegionRef}></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonLabel className="form-label" position="stacked" for="qtyUnitsRef">Country </IonLabel>
                                                {/*<select name="employeeRole" id='employeeRole' ref={(e) => handleCreateEmployeeCompanyRole(e) }>*/}
                                                <select className='professional-input' name="qtyUnitsRef" id='qtyUnitsRef' ref={deliveryCountryRef}>
                                                    <option value='ghana' selected>Ghana</option>

                                                </select>
                                            </IonCol>
                                        </IonRow>
                                        {/*<IonRow>
                                            <IonCol size='12'>
                                                <IonLabel className="form-label" position="stacked">Upload Supporting Documentation</IonLabel>
                                                <IonInput className='professional-input' type='file' name='imageFile' accept="image/*" onIonChange={(e) => selectedFileHandler(e.target.files[0])}></IonInput>
                                            </IonCol>
                                        </IonRow>*/}
                                        <IonRow>
                                            <IonCol size='12'>
                                            {   (authenticatedMerchent_context.initialSetup?.details?.step_1 == true && authenticatedMerchent_context.initialSetup?.details?.step_2 == false) || (
                                                (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '1' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                                            ) ? <IonButton type='submit' className='flash-tutorial' > Confirm Fee Creation </IonButton> 
                                            : <IonButton type='submit'> Confirm Fee Creation </IonButton> }

                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                            
                    </IonContent>
                    <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonButton onClick={() => props.closeModal(false)}>Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonFooter>
                    </form>
                </IonModal>) : null
                }
            </React.Fragment>

    )
}